"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSlowRequestRoute = exports.useMemoryLeakRoute = exports.useExitServer = exports.useErrorRoute = void 0;
var path_1 = __importDefault(require("path"));
function generatePaths(baseRoutePath) {
    var routePath = baseRoutePath || '/';
    return {
        slow: path_1.default.join(routePath, 'slow'),
        memory: path_1.default.join(routePath, 'oom'),
        error: path_1.default.join(routePath, 'error'),
        exit: path_1.default.join(routePath, 'exit'),
    };
}
function authenticatRequest(req, secretToken) {
    var token = req.query.secret ||
        req.query.secretToken ||
        req.headers['x-secret'] ||
        req.headers['x-secret-token'] ||
        req.headers.authorization;
    if (secretToken && token === secretToken) {
        return true;
    }
    throw new Error('not authorized');
}
function handleResponse(cb, res) {
    try {
        cb();
    }
    catch (e) {
        res.send('not ok');
    }
}
function useSlowRequestRoute(options) {
    var getRequestTime = options.getRequestTime ||
        function minMaxGetter() {
            var min = 10000;
            var max = 25000;
            return Math.random() * (max - min) + min;
        };
    var slow = generatePaths(options.baseRoutePath).slow;
    return function (server) {
        server.use(slow, function (req, res) {
            handleResponse(function () {
                authenticatRequest(req, options.secretToken);
                var requestTime = getRequestTime();
                setTimeout(function () {
                    res.send('ok');
                }, requestTime);
            }, res);
        });
    };
}
exports.useSlowRequestRoute = useSlowRequestRoute;
function useMemoryLeakRoute(options) {
    function formatMemoryToMb(bytes) {
        return Math.round((bytes / 1024 / 1024) * 100) / 100 + " mb";
    }
    var memory = generatePaths(options.baseRoutePath).memory;
    var increaseBy = options.memoryObjectIncreaseCount || 1000000000;
    return function (server) {
        var overflow = {};
        var externalCount = 0;
        server.use(memory, function (req, res) {
            handleResponse(function () {
                authenticatRequest(req, options.secretToken);
                var internalCount = 0;
                while (internalCount < increaseBy) {
                    externalCount++;
                    internalCount++;
                    overflow[externalCount] = internalCount;
                    res.send(formatMemoryToMb(process.memoryUsage().rss));
                }
            }, res);
        });
    };
}
exports.useMemoryLeakRoute = useMemoryLeakRoute;
function useErrorRoute(options) {
    return function (server) {
        var error = generatePaths(options.baseRoutePath).error;
        server.use(error, function (req, res) {
            handleResponse(function () {
                authenticatRequest(req, options.secretToken);
                var errorType = req.query.unhandledRejection ? 'unhandledRejection' : 'other';
                switch (errorType) {
                    case 'unhandledRejection':
                        new Promise(function (_, reject) {
                            reject(new Error('unhandledRejection'));
                        });
                        break;
                    default:
                        var err = new Error('default error from debug');
                        options.notifier
                            ? options.notifier.reportServerError({
                                error: err,
                                errorClass: 'debugError',
                                errorLocation: 'debug-route',
                                req: req,
                            })
                            : null;
                        throw err;
                }
            }, res);
        });
    };
}
exports.useErrorRoute = useErrorRoute;
function useExitServer(options) {
    var exit = generatePaths(options.baseRoutePath).exit;
    return function (server) {
        server.use(exit, function (req, res) {
            handleResponse(function () {
                authenticatRequest(req, options.secretToken);
                process.exit();
            }, res);
        });
    };
}
exports.useExitServer = useExitServer;
//# sourceMappingURL=routes.js.map